// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2MkIV";
var _3 = "title-13BP2";
var _4 = "info-1Fg8b";
var _5 = "info__icon-1zl6B";
var _6 = "info__text-zJ2Zi";
var _7 = "ticket-6GIpo";
export { _1 as "__esModule", _2 as "container", _3 as "title", _4 as "info", _5 as "info__icon", _6 as "info__text", _7 as "ticket" }
export default { "__esModule": _1, "container": _2, "title": _3, "info": _4, "info__icon": _5, "info__text": _6, "ticket": _7 }
